module.exports = __webpack_public_path__ + "static/media/tooltip-top.a08a84fd.png";